const pages = {
  service: [
    {
      title: 'Product Engineering',
      href: '/web-development',
    },
    {
      title: 'Mobile App Development',
      href: '/mobile-app-development',
    },
    {
      title: 'Web Design & UI/UX',
      href: '/web-design',
    },
    {
      title: 'Topibro Academy',
      href: '/training',
    },
    {
      title: 'Topibro Workspace & Hub',
      href: '/coworkingspace',
    },
  ],
  about: [
    {
      title: 'About Us',
      href: '/about',
    },
  ],
  blog: [
    {
      title: 'Insights',
      href: '/blog',
    },
  ],
  seminar: [
    {
      title: 'Events',
      href: '/seminar-event',
    },
  ],
  career: [
    {
      title: 'Careers',
      href: '/career-opening',
    },
  ],
  mentor: [
    {
      title: 'Become a mentor',
      href: '/onlineplatform/mentor',
    },
  ],
  create: [
    {
      title: 'Create a course',
      href: '/onlineplatform/create',
    },
  ],
};

export default pages;
